import { ReactNode } from "react";

type SectionProps = {
  className: string;
  children: ReactNode;
};
export const Section = ({ className, children }: SectionProps) => {
  return (
    <div
      className={`w-full rounded-md bg-white p-4 shadow-md sm:p-6 dark:bg-slate-900 ${className}`}
    >
      {children}
    </div>
  );
};
